import styled from '@emotion/styled'
import _ from 'lodash'
import {
  IntegrationFormField,
  IntegrationFormManager,
  IntegrationNameBuilder,
  IntegrationFiltersBuilder,
  AccountSelectionBuilder,
  DataSelectionBuilder,
  SyncScheduleBuilder,
  FieldMappingBuilder,
} from '@admin/templates/edit-template/integrations/integration-forms/components'
import { AmazonDataOptions, AMAZON_DATA_TYPE_KEY } from './components/field-configs'

const FullWidth = styled.div`
  width: 100%;
`

export function AmazonAds({ assignment }) {
  const integrationFieldsFilter = field =>
    _.get(field, 'fieldTypes', [])
      .map(row => row.type)
      .includes(assignment.metadata[AMAZON_DATA_TYPE_KEY])

  const integrationNameField = new IntegrationNameBuilder().build()
  const accountSelectionField = new AccountSelectionBuilder()
    .resetOnChange(true)
    .dataType(assignment.metadata[AMAZON_DATA_TYPE_KEY] || AmazonDataOptions[0].type)
    .build()
  const dataSelectionField = new DataSelectionBuilder()
    .placement(2)
    .dataOptions(AmazonDataOptions)
    .defaultValue(AmazonDataOptions[0].type)
    .metadataKey(AMAZON_DATA_TYPE_KEY)
    .resetIntegrationOnChange(true)
    .build()
  const syncScheduleField = new SyncScheduleBuilder().placement(3).build()

  const integrationFilters = new IntegrationFiltersBuilder()
    .placement(4)
    .dataTypeFilter(assignment.metadata[AMAZON_DATA_TYPE_KEY])
    .build()

  const fieldMapping = new FieldMappingBuilder()
    .placement(5)
    .integrationTitle('Amazon Ads')
    .integrationFieldsFilter(integrationFieldsFilter)
    .dataType(assignment.metadata[AMAZON_DATA_TYPE_KEY] || AmazonDataOptions[0].type)
    .build()

  const AmazonAdsFormFields: IntegrationFormField[] = [
    integrationNameField,
    accountSelectionField,
    dataSelectionField,
    syncScheduleField,
    integrationFilters,
    fieldMapping,
  ]

  return (
    <FullWidth>
      <IntegrationFormManager
        integrationType="amazon-ads-inbound"
        integrationAssignment={assignment}
        integrationFields={AmazonAdsFormFields}
      />
    </FullWidth>
  )
}
